import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SimpleHeaderComponent } from './simple-header/simple-header.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginPopupComponent } from './login-popup/login-popup.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        SimpleHeaderComponent,
        LoginPopupComponent,
    ],
    imports: [    
		CommonModule,
		IonicModule,
        MatButtonModule, 
        MatMenuModule,
        FontAwesomeModule,
        FormsModule, ReactiveFormsModule,
        TranslateModule.forChild({
            loader: {
              provide: TranslateLoader,
              useFactory: createTranslateLoader,
              deps: [HttpClient]
            }
          })
	],
    exports: [
        HeaderComponent,
        FooterComponent,
        SimpleHeaderComponent,
        LoginPopupComponent,
    ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
